import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { WebClient } from '@injectables';
import { op } from '@lib/rxjs';
import { Site, Client, User } from '@models';

interface Input {
  record: Site;
}

@Component({
  selector: 'site-edit-dialog',
  templateUrl: './site-edit-dialog.component.html',
  styleUrls: ['./site-edit-dialog.component.scss'],
})
export class SiteEditDialog implements OnInit {
  static readonly config: MatDialogConfig<Input> = {
    autoFocus: false,
    disableClose: true,
  };

static readonly output: boolean = true;


  public readonly clients$ = this.webClient.model.client
    .search$({})
    .pipe(op.startWith([] as Client[]));

  public record: Site = this.input.record;
  public client: Client;
  public name: string = this.record.name ?? '';
  public enabled: boolean = this.record.enabled;

  constructor(
    public readonly user: User,
    private readonly webClient: WebClient,
    private host: MatDialogRef<boolean>,
    @Inject(MAT_DIALOG_DATA) private readonly input: Input
  ) {}

  public ngOnInit(): void {
    // preload this record's client so the dropdown shows it selected
    this.clients$
      .pipe(op.map((clients) => clients.find((c) => c.id === this.record.clientId)))
      .subscribe((c) => {
        this.client = c;
      });
  }

  // Display function for the autocomplete dropdown
  public clientDisplayWith(client: Client): string {
    return client?.name ?? '';
  }

  // Handler when user picks a different client
  public onClientSelected(client: Client): void {
    this.client = client;
  }

  // Form validation 
  public valid(): boolean {
    return !!this.client && !!this.name.trim();
  }

  //  Cancel without saving 
  public cancel(): void {
    this.host.close(false);
  }

  //  Save the changes back to the record 
  public save(): void {
    this.record.clientId = this.client.id;
    this.record.name = this.name;
    this.record.enabled = this.enabled;
    this.host.close(true);
  }
}
